<template>
    <div class="footer  pt-4 pb-4 ">
        <footer class="footer-container ">            
            
            <div class="col-12 text-left d-lg-flex mt-4 pt-lg-2">
                <div class="col-lg-3">
                    <div col="">
                        <img src="../assets/Logo.svg" class="MainNewLogo img-fluid" alt="logo">
                    </div>
                </div>
                <div class="d-flex justify-content-between col-lg-9 padding-left mt-4 mt-lg-2">
                    <div class="col-md-3 col-lg-3">
                        <h5 class="blue proximanova-bold">General</h5>
                        <ul class="list-unstyled text-small">
                            <li class="text-muted pointer" @click="Navtosignup">Sign In/ Sign Up</li>
                            <li class="text-muted pointer mt-1" @click="navToHowitworks">How it works</li>
                            <li class="text-muted pointer mt-1" @click="navToPricing">Pricing</li>
                            <li class="text-muted pointer mt-1" @click="navToContentCreators">Content Creators</li>
                            <li class="text-muted pointer mt-1" @click="navToStudentAmbassadorProgramme">Student Ambassador programme</li>
                            <!-- <li><a class="text-muted" href="#">About US</a></li>
                            <li><a class="text-muted" href="#">Careers</a></li>
                            <li><a class="text-muted" href="#">Blogs</a></li>
                            <li><a class="text-muted" href="#">Team</a></li> -->
                            
                        </ul>
                    </div>
                    <!-- <div class="col-md-3 col-lg-3">
                        <h5 class="blue proximanova-bold">Quick access</h5>
                        <ul class="list-unstyled text-small">
                            <li class="text-muted pointer" @click="navToInternalUser">Internal User</li> -->
                            <!-- <li class="text-muted pointer">Find Job</li>
                            <li class="text-muted pointer">Track Status</li>
                            <li class="text-muted pointer">Connect People</li>
                            <li class="text-muted pointer">Post Video's</li>
                            <li class="text-muted pointer">Profile</li> -->
                        <!-- </ul>
                    </div> -->
                    <div class="d-none d-md-block col-md-3 col-lg-3">
                        <h5 class="blue proximanova-bold">Products</h5>
                        <ul class="list-unstyled text-small">
                            <li class="text-muted pointer" @click="navTouser">For Professional</li>
                            <li class="text-muted pointer mt-1" @click="navToBusiness">For Business</li>
                            <li class="text-muted pointer mt-1" @click="navToPostjob">Recruiter</li>
                            <!-- <li class="text-muted pointer">Find Job</li>
                            <li class="text-muted pointer">Track Status</li>
                            <li class="text-muted pointer">Connect People</li>
                            <li class="text-muted pointer">Post Video's</li>
                            <li class="text-muted pointer">Profile</li> -->
                        </ul>
                    </div>
                    <div class="d-none d-md-block col-md-3 col-lg-3">
                        <ul class="list-unstyled text-small">
                            <li class="text-muted pointer"><a :href="wndata.termsandConditions" target="_blank" rel="noopener noreferrer" class="text-muted proximanova">Terms & Conditions</a></li>
                            <li class="text-muted pointer mt-1"><a :href="wndata.privacypolicy" target="_blank" rel="noopener noreferrer" class="text-muted proximanova">Privacy & Policies</a></li>
                        </ul>
                    </div>
                    <div class="d-none d-md-block col-md-3 col-lg-3">
                        <div @click="OpenHelpcenterPDF" class="pointer check">
                          <img src="../assets/Help_landing.svg" class="img-fluid mr-1" alt="help"/>

                          <label class="mr-3 help proximanova pointer">Help</label>
                        </div>
                        <!-- <a href="#" 
                            :class="{'list-text-color border-tab':activeClass == 'people'}"
                            id="people"                                                            
                            >People</a>
                        <img src="../assets/Help_landing.svg" class="img-fluid" alt="">
                        <h5>Help</h5> -->
                        <!-- <ul class="list-unstyled text-small">
                            <li><a class="text-muted" href="#">Find Job</a></li>
                            <li><a class="text-muted" href="#">Track Status</a></li>
                            <li><a class="text-muted" href="#">Connect People</a></li>
                            <li><a class="text-muted" href="#">Post Videos</a></li>
                            <li><a class="text-muted" href="#">Profile</a></li>
                        </ul> -->
                    </div>
                </div>
                <div class="d-block d-md-none d-flex justify-content-between col-lg-6 padding-left mt-2 mt-md-4 mt-lg-2">
                    <div class="col-md-3 col-lg-4">
                        <h5 class="blue proximanova-bold">Products</h5>
                        <ul class="list-unstyled text-small">
                            <li class="text-muted pointer" @click="navTouser">For Professional</li>
                            <li class="text-muted pointer mt-1" @click="navToBusiness">For Business</li>
                            <li class="text-muted pointer mt-1" @click="navToPostjob">Recruiter</li>
                        </ul>
                    </div>
                    <div class="col-md-3 col-lg-4">
                        <span @click="openhelpbrochure" class="pointer">
                          <img src="../assets/Help_landing.svg" class="img-fluid mr-1" alt="help"/>

                          <label class="mr-3 help proximanova pointer">Help</label>
                        </span>
                    </div>
                </div>
                
            </div>
            <div class="mt-4">
                <center class="proximanova fontsize12 black60 text-muted"><span class="fontsize16">&#169;</span> 2022 Worknotion. All rights reserved</center>
            </div>
        </footer>
    </div>
</template>
<script>
import router from '../router'
import wndata from '../js/wn_data.json'
export default {
    data() {
        return{
            wndata : {},
        }
    },
    mounted() {
        this.wndata = wndata;
    },
    methods : {
        navTouser(){
            window.scrollTo({ top: 0, behavior: 'smooth' })
            router.push({
                name : 'LandingPage'
            })
        },
        navToBusiness(){
            var x = document.createElement('a')
            x.target = '_blank'
            x.href = wndata.companyAccountWebapp;
            x.click()
        },
        navToPostjob() {
            var x = document.createElement('a')
            x.target = '_blank'
            x.href = wndata.postajobModuleWebapp;
            x.click()
        },
        NavContactUs : function() {
            router.push({
                name : 'contactUs'
            })
        },
        Navtosignup(){
            router.push({
                name : 'signup'
            })
        },
        // navToInternalUser(){
        //     localStorage.setItem("userType", 'InternalUser')
        //     router.push({
        //         name : 'signin'
        //     })
        // },
        navToHowitworks() {
            router.push({
                name : 'howitworks'
            })
        },
        navToPricing() {
            router.push({
                name : 'pricing'
            })
        },
        navToContentCreators() {
            router.push({
                name : 'content_creators'
            })
        },
        navToStudentAmbassadorProgramme() {
            router.push({
                name : 'student_ambassador_programme'
            })
        },
        OpenHelpcenterPDF(){
        var link=document.createElement('a');
        document.body.appendChild(link);
        link.href="./help_center.pdf"
        link.target = '_blank';
        link.click();
      },
        openhelpbrochure() {
            var link=document.createElement('a');
            document.body.appendChild(link);
            link.href="./help_center.pdf"
            link.target = '_blank';
            link.click();
        }
    }
}
</script>
<style scoped>
.container{
    width: 100%;
}
.footer-container{
    margin: 20px;
}
.text-muted:hover{
    color: #6c757d !important;
}
.help {
  height: 19px;
  width: 34px;
  color: #EA5184;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
}
    .requestbtn {
        margin-left: 8px;
        padding: 8px 20px;
        -webkit-align-self: flex-start;
        -ms-flex-item-align: start;
        align-self: flex-start;
        border-radius: 9px;
        font-size: 12px;
        background-color: #007AFF;
        box-shadow: 0 1px 2px 0 rgba(23,24,26,.1);
        color: #fff;
        font-size: 16px;
        text-align: center;
    }
    .copyright {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        color: rgba(255, 255, 255, .6);
    }
    .font16-opacity30{
        font-family: Arial, Helvetica, sans-serif;
        font-size: 16px;
        color: #FFFFFF;
        opacity: 30%;
    }
    .padding-left{
        padding-left: 5px !important;
        
    }
</style>